import type { ApiCursorBody, ApiResponse } from '@/types/api-response.types'
import type { Mentor, MentorDetail } from '@/types/mentor.types'
import api from '../axios'

export const mentorService = {
  async getMentors(cursor: number | null, size: number, { ascending = false }): Promise<ApiCursorBody<Mentor>> {
    const response: ApiResponse<ApiCursorBody<Mentor>> = await api.get('/v1/mentor', {
      params: {
        cursor,
        size,
        ascending,
      },
    })
    return response.body
  },

  async getMentorDetail(idx: number): Promise<MentorDetail> {
    const response: ApiResponse<MentorDetail> = await api.get(`/v1/mentor/${idx}`)
    return response.body
  },
}
